import Vue from 'vue';
// https://www.npmjs.com/package/vue-notifications
import VueNotifications from 'vue-notifications';
// https://www.npmjs.com/package/mini-toastr
import miniToastr from 'mini-toastr';

// If using mini-toastr, provide additional configuration
const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({
  types: toastTypes,
  timeout: 10000,
});

miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'});
miniToastr.setIcon('warn', 'i', {'class': 'fa fa-warning'});
miniToastr.setIcon('info', 'i', {'class': 'fa fa-info-circle'});
miniToastr.setIcon('success', 'i', {'class': 'fa fa-check-circle-o'});

// Here we setup messages output to `mini-toastr`
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb);
}

// Binding for methods .success(), .error() and etc. You can specify and map your own methods here.
// Required to pipe our output to UI library (mini-toastr in example here)
// All not-specified events (types) would be piped to output in console.
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options);